import { AuditAudioInMatch, AuditMatch, Seconds } from '@mi-front/core';
import { Duration } from '@mi-front/ui';
import OutlinedFlagIcon from '@mui/icons-material/OutlinedFlag';
import { Box } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { LTime } from '../../../../components/date/LTime';
import { MatchStatuses } from './MatchStatuses';
import { PlayButton } from './PlayButton';
import { ShareButton } from './ShareButton';
import { Pre, Title, Wrapper } from './elements';

function InfoCustom(p: { audio: AuditAudioInMatch }) {
  const { $t } = useIntl();
  return (
    <>
      <Pre>
        {$t({
          id: 'audit.result.label',
          defaultMessage: 'Resultado de auditoría',
        })}
      </Pre>
      <Title>{p.audio.customId || p.audio.title}</Title>
    </>
  );
}

export function Info(p: { match: AuditMatch }) {
  const { match } = p;

  return (
    <Wrapper>
      <Box mb={0.5}>
        <InfoCustom audio={match.audio!} />
      </Box>

      <Box display="flex" alignItems="center">
        <OutlinedFlagIcon fontSize="small" />
        <LTime value={match.datetime} />{' '}
        <FormattedMessage id="audit.result.durationPrefix" defaultMessage=" (" />
        <Duration seconds={(match.audio!.duration / 1000) as Seconds} />)
      </Box>

      <Box my={1}>
        <MatchStatuses match={match} />
      </Box>

      <Box mt={2} display="flex" gap={1}>
        <PlayButton match={match} />
        <ShareButton match={match} />
      </Box>
    </Wrapper>
  );
}
